module.exports = __webpack_public_path__ + "img/advanced-image-second.78b1c867.jpg";